import * as React from 'react'
import Highlighter from 'react-highlight-words'

import styles from './Highlight.module.scss'

export interface IProps {
  words?: string[]
  element?: string
  children: string | string[]
  className?: string
}

export const Highlight = ({ words, children, className }: IProps) => {
  const text = typeof children === 'object' ? children.join('') : children
  return (
    <Highlighter
      highlightClassName={styles.highlight}
      searchWords={words || []}
      autoEscape={true}
      textToHighlight={text}
      className={className}
    />
  )
}
